export { default } from './PatientDetailsNavigation';
